import { render, staticRenderFns } from "./ViewComponent.vue?vue&type=template&id=f509e966&"
import script from "./ViewComponent.vue?vue&type=script&lang=ts&"
export * from "./ViewComponent.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports